import { Button } from "@/components/ui/button";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import type { Alert } from "@medical-association/shared";
import { useState } from "react";

const AlertManagement = () => {
	const [alerts, setAlerts] = useState<Alert[]>([]);
	const [isAddingNew, setIsAddingNew] = useState(false);

	return (
		<div className="space-y-6">
			<div className="flex justify-between items-center">
				<h2 className="text-2xl font-semibold">Alert Management</h2>
				<Button onClick={() => setIsAddingNew(true)}>
					Configure New Alert
				</Button>
			</div>

			<Table>
				<TableHeader>
					<TableRow>
						<TableHead>Title</TableHead>
						<TableHead>Type</TableHead>
						<TableHead>Recipients</TableHead>
						<TableHead>Status</TableHead>
						<TableHead>Actions</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{alerts.map((alert) => (
						<TableRow key={alert.id}>
							<TableCell>{alert.title}</TableCell>
							<TableCell>{alert.type}</TableCell>
							<TableCell>
								{alert.recipients.levels?.join(", ") || "All Members"}
							</TableCell>
							<TableCell>Active</TableCell>
							<TableCell>
								<Button variant="outline" size="sm">
									Edit
								</Button>
								<Button variant="destructive" size="sm">
									Delete
								</Button>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
};

export default AlertManagement;
